import React, {useEffect, useMemo, useState} from "react";
import {
    Button,
    DatePicker,
    Dialog,
    Form,
    IndexBar,
    Input,
    Modal,
    NavBar,
    Picker,
    SearchBar,
    Selector,
    Toast
} from "antd-mobile";
import {useNavigate} from "react-router-dom";
import dayjs from 'dayjs'
import {TOASTDURATION} from "../../common/Utils";
import {
    codeCity,
    codeCountry, configOfMemorySize, configOfModels,
    getAllLoanProduct, storeListAll,
    userCheckByIdNum,
    userCheckByMobile
} from "../../common/ApiAction";
import {useTranslation} from "react-i18next";
import './createOrder.css'

// 数据类型定义
interface Store {
    id: string;
    storeName: string;
    storeAddress: string;
    status: string;
    bdName: string;
    rawCreateTime: string;
    rawUpdateTime: string;
}

type pickerType = {
    label: string,
    value: string
}

const operatorLockList = [
    {
        label: 'No',
        value: '0'
    },
    {
        label: 'Yes',
        value: '1'
    }
]

// const orderTypeList = [
//     {
//         label: 'Internal',
//         value: 'Internal'
//     },
//     {
//         label: 'External_1',
//         value: 'External_1'
//     },
//     {
//         label: '1',
//         value: '1'
//     },
//     {
//         label: '2',
//         value: '2'
//     },
//     {
//         label: '3',
//         value: '3'
//     }
// ]

const CreateOrder = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [countList, setCountList] = useState<pickerType[]>([]);
    const { t } = useTranslation();
    const [cityList, setCityList] = useState<pickerType[]>([]);
    const [districtList, setDistrictList] = useState<pickerType[]>([]);
    const [cityParentId, setCityParentId] = useState('100000');
    const [districtParentId, setDistrictParentId] = useState('100000');
    const [storesList, setStoresList] = useState<Store[]>([]);
    const [storeSelectorVisible, setStoreSelectorVisible] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [selectedStore, setSelectedStore] = useState<Store | null>(null);
    const [phoneList, setPhoneList] = useState<pickerType[]>([]);
    const [memoryList, setMemoryList] = useState<pickerType[]>([]);
    const [loanDaysList, setLoanDaysList] = useState<pickerType[]>([]);

    // 分组店铺数据
    const groupedStores = useMemo(() => {
        const grouped: { [key: string]: Store[] } = {};

        storesList.forEach(store => {
            // 去掉空格
            const storeName = store.storeName.trim();
            const firstChar = storeName.charAt(0).toUpperCase();
            const groupKey = /[A-Z]/.test(firstChar) ? firstChar : '#';
            if (!grouped[groupKey]) {
                grouped[groupKey] = [];
            }
            grouped[groupKey].push(store);
        });

        // 按字母顺序排序
        const sortedGroups: { [key: string]: Store[] } = {};
        Object.keys(grouped)
            .sort()
            .forEach(key => {
                sortedGroups[key] = grouped[key];
            });
        return sortedGroups;
    }, [storesList]);

    // 过滤后的分组店铺数据
    const filteredGroupedStores = useMemo(() => {
        if (!searchValue) return groupedStores;
        const filtered: { [key: string]: Store[] } = {};
        Object.keys(groupedStores).forEach(key => {
            const filteredStores = groupedStores[key].filter(store =>
                store.storeName.toLowerCase().includes(searchValue.toLowerCase())
                // store.storeAddress.toLowerCase().includes(searchValue.toLowerCase())
            );
            if (filteredStores.length > 0) {
                filtered[key] = filteredStores;
            }
        });
        return filtered;
    }, [groupedStores, searchValue]);


    // const loanDaysList = [
    //     {
    //         label: t('create_order_loan_3_months'), // 使用翻译
    //         value: 1
    //     },
    //     {
    //         label: t('create_order_loan_6_months_24'), // 使用翻译
    //         value: 2
    //     },
    //     {
    //         label: t('create_order_loan_6_months_12'), // 使用翻译
    //         value: 3
    //     },
    //     {
    //         label: t('create_order_loan_4_months'), // 使用翻译
    //         value: 4
    //     },
    //     {
    //         label: t('create_order_loan_5_months'), // 使用翻译
    //         value: 5
    //     },
    //     {
    //         label: t('create_order_loan_1_months'), // 使用翻译
    //         value: 6
    //     },
    //     {
    //         label: t('create_order_loan_2_months'), // 使用翻译
    //         value: 7
    //     },
    //     {
    //         label: t('create_order_loan_type_8'), // 使用翻译
    //         value: 8
    //     }
    // ];
    //
    // const loanDaysListOfAbidjan  = [
    //     {
    //         label: t('create_order_loan_3_months'), // 使用翻译
    //         value: 1
    //     },
    //     {
    //         label: t('create_order_loan_6_months_24'), // 使用翻译
    //         value: 2
    //     },
    //     {
    //         label: t('create_order_loan_6_months_12'), // 使用翻译
    //         value: 3
    //     },
    //     {
    //         label: t('create_order_loan_4_months'), // 使用翻译
    //         value: 4
    //     },
    //     {
    //         label: t('create_order_loan_5_months'), // 使用翻译
    //         value: 5
    //     },
    //     {
    //         label: t('create_order_loan_1_months'), // 使用翻译
    //         value: 6
    //     },
    //     {
    //         label: t('create_order_loan_2_months'), // 使用翻译
    //         value: 7
    //     },
    //     {
    //         label: t('create_order_loan_type_8'), // 使用翻译
    //         value: 8
    //     },
    //     {
    //         label: t('create_order_loan_type_9'), // 使用翻译
    //         value: 9
    //     },
    //     {
    //         label: t('create_order_loan_type_10'), // 使用翻译
    //         value: 10
    //     },
    //     {
    //         label: t('create_order_loan_type_11'), // 使用翻译
    //         value: 11
    //     }
    // ];
    //
    // const loanDaysListOfDakar  = [
    //     {
    //         label: t('create_order_loan_3_months'), // 使用翻译
    //         value: 1
    //     },
    //     {
    //         label: t('create_order_loan_6_months_24'), // 使用翻译
    //         value: 2
    //     },
    //     {
    //         label: t('create_order_loan_6_months_12'), // 使用翻译
    //         value: 3
    //     },
    //     {
    //         label: t('create_order_loan_4_months'), // 使用翻译
    //         value: 4
    //     },
    //     {
    //         label: t('create_order_loan_5_months'), // 使用翻译
    //         value: 5
    //     },
    //     {
    //         label: t('create_order_loan_1_months'), // 使用翻译
    //         value: 6
    //     },
    //     {
    //         label: t('create_order_loan_2_months'), // 使用翻译
    //         value: 7
    //     },
    //     {
    //         label: t('create_order_loan_type_8'), // 使用翻译
    //         value: 8
    //     },
    //     {
    //         label: t('create_order_loan_type_9_dark'), // 使用翻译
    //         value: 9
    //     }
    // ];

    // /**
    //  * 内存列表
    //  */
    // const memoryList = [
    //     {
    //         label: '64GB',
    //         value: '64GB'
    //     },
    //     {
    //         label: '128GB',
    //         value: '128GB'
    //     },
    //     {
    //         label: '256GB',
    //         value: '256GB'
    //     },
    //     {
    //         label: '512GB',
    //         value: '512GB'
    //     },
    //     {
    //         label: '1TB',
    //         value: '1TB'
    //     },
    //     {
    //         label: '2TB',
    //         value: '2TB'
    //     }
    // ];

    // /**
    //  * phoneList 型号
    //  */
    // const phoneModel = [
    //     'iPhone SE',
    //     'iPhone 7',
    //     'iPhone 7 Plus',
    //     'iPhone 8',
    //     'iPhone 8 Plus',
    //     'iPhone X',
    //     'iPhone XR',
    //     'iPhone XS',
    //     'iPhone XS Max',
    //     'iPhone 11',
    //     'iPhone 11 Pro',
    //     'iPhone 11 Pro Max',
    //     'iPhone SE 2',
    //     'iPhone 12',
    //     'iPhone 12 mini',
    //     'iPhone 12 Pro',
    //     'iPhone 12 Pro Max',
    //     'iPhone 13',
    //     'iPhone 13 mini',
    //     'iPhone SE3',
    //     'iPhone 13 Pro',
    //     'iPhone 13 Pro Max',
    //     'iPhone 14',
    //     'iPhone 14 Plus',
    //     'iPhone 14 Pro',
    //     'iPhone 14 Pro Max',
    //     'iPhone 15',
    //     'iPhone 15 Plus',
    //     'iPhone 15 Pro',
    //     'iPhone 15 Pro Max',
    //     'iPhone 16',
    //     'iPhone 16 Plus',
    //     'iPhone 16 Pro',
    //     'iPhone 16 Pro Max',
    //     'iPhone 16e',
    //     'iPhone 17',
    //     'iPhone 17 Air',
    //     'iPhone 17 Plus',
    //     'iPhone 17 Pro',
    //     'iPhone 17 Pro Max',
    //     'iPhone 18',
    //     'iPhone 18 Pro',
    //     'iPhone 18 Pro Max',
    //     'iPhone Air',
    //     'iPad (7th gen)',
    //     'iPad (8th gen)',
    //     'iPad (9th gen)',
    //     'iPad (10th gen)',
    //     'iPad (11th gen)',
    //     'iPad mini (6th)',
    //     'iPad mini (7th)',
    //     'iPad Air (4th)',
    //     'iPad Air (5th)',
    //     'iPad Air (6th)',
    //     'iPad Air (7th)',
    //     'iPad Pro (5th)',
    //     'iPad Pro (6th)',
    //     'iPad Pro (7th)',
    //     'iPad Pro (8th)',
    // ];
    // const phoneList = phoneModel.map(item => ({
    //     label: item,
    //     value: item
    // }))

    useEffect(() => {
        const _getCodeCountry = () => {
            codeCountry().then((res: any) => {
                if (!res.executed) {
                    Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
                } else {
                    const list: pickerType[] = [];
                    res.data.forEach((e: any) => {
                        const item: pickerType = {
                            label: e.enName,
                            value: e.cityCodeId
                        }
                        list.push(item);
                    });
                    setCountList(list);
                }
            })
        }
        const _getPhoneModels = () => {
            configOfModels().then((res: any) => {
                if (!res.executed) {
                    Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
                } else {
                    const list: pickerType[] = [];
                    res.data.forEach((e: any) => {
                        const item: pickerType = {
                            label: e.name,
                            value: e.code
                        }
                        list.push(item);
                    });
                    setPhoneList(list);
                }
            })
        }
        const _getPhoneMemorySize = () => {
            configOfMemorySize().then((res: any) => {
                if (!res.executed) {
                    Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
                } else {
                    const list: pickerType[] = [];
                    res.data.forEach((e: any) => {
                        const item: pickerType = {
                            label: e.name,
                            value: e.code
                        }
                        list.push(item);
                    });
                    setMemoryList(list);
                }
            })
        }
        const _getLoanDaysList = () => {
            getAllLoanProduct().then((res: any) => {
                if (!res.executed) {
                    Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
                } else {
                    const list: pickerType[] = [];
                    res.data.forEach((e: any) => {
                        const item: pickerType = {
                            label: e.lableEn,
                            value: e.id
                        }
                        list.push(item);
                    });
                    setLoanDaysList(list);
                }
            })
        }
        const _getStoreListAll = () => {
            Toast.show({icon: 'loading', content: 'Login...', duration: 0})
            storeListAll().then((res: any) => {
                Toast.clear()
                if (res.executed) {
                    setStoresList(res.data)
                }
            }).catch(err => {
                Toast.clear()
            })
        }
        _getCodeCountry();
        _getLoanDaysList();
        _getStoreListAll();
        _getPhoneModels();
        _getPhoneMemorySize();
    }, []);

    // 处理店铺选择
    const handleStoreSelect = (store: Store) => {
        setStoreSelectorVisible(false);
        setSearchValue('');
        setSelectedStore(store);
        // 同步更新表单字段值
        form.setFieldsValue({ store: store.id });
        Toast.show({
            icon: 'success',
            content: `Selected: ${store.storeName}`
        });
    };


    useEffect(() => {
        codeCity({parentId: cityParentId}).then((res: any) => {
            if (!res.executed) {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            } else {
                const list: pickerType[] = [];
                res.data.forEach((e: any) => {
                    const item: pickerType = {
                        label: e.enName,
                        value: e.cityCodeId
                    }
                    list.push(item);
                });
                setCityList(list);
            }
        })
    }, [cityParentId]);
    useEffect(() => {
        codeCity({parentId: districtParentId}).then((res: any) => {
            if (!res.executed) {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            } else {
                const list: pickerType[] = [];
                res.data.forEach((e: any) => {
                    const item: pickerType = {
                        label: e.enName,
                        value: e.cityCodeId
                    }
                    list.push(item);
                });
                setDistrictList(list);
            }
        })
    },[districtParentId])
    const back = () => {
        navigate(-1);
    };
    const _getcountryDesc = (val: any, isCity: boolean, isCommon: boolean) => {
        if (Object.keys(val).length) {
            const item = val[0];
            if (item) {
                if (!isCity && !isCommon) {
                    setCityParentId(item.value)
                }
                return item.label
            }
        }
        return t('create_order_select');
    }
    const _getDistrictDesc = (val: any) => {
        if (Object.keys(val).length) {
            const item = val[0];
            if (item) {
                setDistrictParentId(item.value)
                return item.label
            }
        }
        return t('create_order_select');
    }
    const _getCommonDesc = (val: any) => {
        if (Object.keys(val).length) {
            const item = val[0];
            if (item) {
                return item.label
            }
        }
        return t('create_order_select');
    }
    const onFinish = (values: any) => {
        Toast.show({icon: 'fail', content: "Currently not supported. Please use the App", duration: TOASTDURATION})
        // let userInfo : API.CurrentUser | null = getLoginUserInfo();
        // if (!userInfo) {
        //     Toast.show({icon: 'fail', content: "Not Login!", duration: TOASTDURATION})
        //     return;
        // }
        // if (parseFloat(values['orderInfo.downPayment']) >= parseFloat(values['orderInfo.price'])) {
        //     Toast.show({icon: 'fail', content: "Order down payment cannot be greater than the selling price！", duration: TOASTDURATION})
        //     return;
        // }
        // if (values['orderInfo.contractDate']) {
        //     values['orderInfo.contractDate'] = moment(values['orderInfo.contractDate']).format('YYYY-MM-DD')
        // }
        // if (values['orderInfo.loanDaysType']) {
        //     values['orderInfo.loanDaysType'] = values['orderInfo.loanDaysType'][0];
        // }
        // if (values['orderInfo.orderType']) {
        //     values['orderInfo.orderType'] = values['orderInfo.orderType'][0];
        // }
        // if (values['productInfo.operatorLock']) {
        //     values['productInfo.operatorLock'] = values['productInfo.operatorLock'][0];
        // }
        // if (values['orderInfo.countryCode']) {
        //     values['orderInfo.countryCode'] = values['orderInfo.countryCode'][0];
        // }
        // if (values['orderInfo.cityCode']) {
        //     values['orderInfo.cityCode'] = values['orderInfo.cityCode'][0];
        // }
        // if (values['orderInfo.districtCode']) {
        //     values['orderInfo.districtCode'] = values['orderInfo.districtCode'][0];
        // }
        // if (values['productInfo.model']) {
        //     values['productInfo.model'] = values['productInfo.model'][0];
        // }
        // if (values['productInfo.memorySize']) {
        //     values['productInfo.memorySize'] = values['productInfo.memorySize'][0];
        // }
        // if (selectedStore) {
        //     values['orderInfo.storeInfoId'] = selectedStore.id;
        // }
        // values['orderInfo.salesmanInfoId'] = userInfo.id;
        // values['orderSource'] = 'H5'
        // const result = {};
        // for (const key in values) {
        //     const keys = key.split('.');
        //     keys.reduce((acc: any, cur, idx) => {
        //         if (idx === keys.length - 1) {
        //             acc[cur] = values[key];
        //         } else {
        //             acc[cur] = acc[cur] || {};
        //         }
        //         return acc[cur];
        //     }, result);
        // }
        // Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        // checkUserInfo(result).then((res: any) => {
        //     if (res.executed) {
        //         createOrderAction(result)
        //     } else {
        //         Dialog.confirm({
        //             title: res.message,
        //             onConfirm: () => {
        //                 createOrderAction(result)
        //             },
        //             onCancel: () => {
        //                 Toast.clear();
        //             }
        //         })
        //     }
        // })
    }
    // const createOrderAction = (data: any) => {
    //     createOrder(data).then((res: any) => {
    //         Toast.clear();
    //         if (!res.executed) {
    //             Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
    //         } else {
    //             Toast.show({
    //                 content: 'Create Order Success',
    //                 duration: TOASTDURATION,
    //                 icon: 'success',
    //                 afterClose: () => {
    //                     navigate(-1);
    //                 }
    //             });
    //         }
    //     }).catch((err: any) => {
    //         Toast.show({icon: 'fail', content: err.message, duration: TOASTDURATION})
    //     })
    // }
    const checkByMobile = (e: React.MouseEvent) => {
        e.stopPropagation()
        const mobile = form.getFieldValue('userInfo.mobile');
        if (mobile) {
            Toast.show({icon: 'loading', content: 'Login...', duration: 0})
            userCheckByMobile(mobile).then((res: any) => {
                Toast.clear();
                if (res.executed) {
                    if (Array.isArray(res.data) && res.data.length) {
                        let resContent: string = `${mobile} at `;
                        res.data.forEach((e: any) => {
                            resContent += `${e.contractDate}\n`
                        })
                        resContent += 'already create order';
                        Dialog.confirm({
                            title: resContent,
                            onConfirm: () => {},
                            onCancel: () => {},
                        })
                    }
                }
            }).catch((err: any) => {
                Toast.clear();
            })
        } else {
            Toast.show({icon: 'fail', content: 'Please input mobile!', duration: TOASTDURATION})
        }
    }
    const checkByIdNum = (e: React.MouseEvent) => {
        e.stopPropagation()
        const idNum = form.getFieldValue('userInfo.idNum');
        if (idNum) {
            userCheckByIdNum(idNum).then((res: any) => {
                Toast.clear();
                if (res.executed) {
                    if (Array.isArray(res.data) && res.data.length) {
                        let resContent: string = `${idNum} at `;
                        res.data.forEach((e: any) => {
                            resContent += `${e.contractDate}\n`
                        })
                        resContent += 'already create order';
                        Dialog.confirm({
                            title: resContent,
                            onConfirm: () => {},
                            onCancel: () => {},
                        })
                    }
                }
            }).catch((err: any) => {
                Toast.clear();
            })
        } else {
            Toast.show({icon: 'fail', content: 'Please input idNum!', duration: TOASTDURATION})
        }
    }
    /**
     * 姓名，身份证号，年龄，手机号码 ,紧急联系人，紧急联系人电话
     * 手机型号，内存，颜色，序列码
     * 商户名称，业务员
     * 商品金额，首付金额，租赁周期
     */
    return <div style={{display: "flex", flexDirection: "column", width: '100%', backgroundColor: '#F5F6FA'}}>
        <NavBar style={{backgroundColor: '#FFF'}} onBack={back}>{t('create_order_title')}</NavBar>
        <div>
            <Form
                onFinish={onFinish}
                mode={'card'}
                form={form}
                requiredMarkStyle='asterisk'
                footer={<Button shape='rounded' type='submit' block color='primary' size='middle'>{t('create_order_submit')}</Button>}>
                <Form.Header>{t('create_order_user_info')}</Form.Header>
                <Form.Item name='userInfo.userName' label={t('create_order_user_name')} rules={[{ required: true, message: t('create_order_required') }]}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item extra={<Button color='primary' onClick={checkByMobile}>Check</Button>} name='userInfo.mobile' label={t('create_order_user_mobile')} rules={[{ required: true, message: t('create_order_required') }]}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item extra={<Button color='primary' onClick={checkByIdNum}>Check</Button>} name='userInfo.idNum' label={t('create_order_id_number')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='userInfo.address' label={t('create_order_address')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='userInfo.email' label={t('create_order_email')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='userInfo.staff' label={t('create_order_staff')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='userInfo.emergencyContact' label={t('create_order_emergency_contact')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='userInfo.emergencyMobile' label={t('create_order_emergency_mobile')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='userInfo.paymentAccount' label={t('create_order_user_paymentAccount')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Header>{t('create_order_product_info')}</Form.Header>
                <Form.Item name='productInfo.model'
                           label={t('create_order_product_name')}
                           trigger='onConfirm'
                           onClick={(e, pickerRef) => {
                               pickerRef.current?.open();
                           }}
                           rules={[{ required: true, message: t('create_order_required') }]}>
                    <Picker columns={[phoneList]}>
                        {value => value ? _getCommonDesc(value) : t('create_order_product_name')}
                    </Picker>
                </Form.Item>
                <Form.Item name='productInfo.serialNumber' label={t('create_order_product_serial_number')} rules={[{ required: true, message: t('create_order_required') }]}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item
                    name='productInfo.operatorLock'
                    label={t('create_order_product_operator_lock')}
                    rules={[{ required: process.env.REACT_APP_ENV === 'production04', message: t('create_order_select_operator_lock') }]}>
                    <Selector options={operatorLockList} />
                </Form.Item>
                <Form.Item name='productInfo.memorySize'
                           label={t('create_order_product_memory_size')}
                           trigger='onConfirm'
                           onClick={(e, pickerRef) => {
                               pickerRef.current?.open();
                           }}
                           rules={[{ required: true, message: t('create_order_required') }]}>
                    <Picker columns={[memoryList]}>
                        {value => value ? _getCommonDesc(value) : t('create_order_product_memory_size')}
                    </Picker>
                </Form.Item>
                <Form.Item name='productInfo.color' label={t('create_order_product_color')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='productInfo.imei' label={t('create_order_product_imei')}>
                    <Input placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Header>{t('create_order_order_info')}</Form.Header>
                <Form.Item name='orderInfo.price' label={t('create_order_order_price')} rules={[{ required: true, message: t('create_order_required') }]}>
                    <Input type={"number"} placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item name='orderInfo.downPayment' label={t('create_order_down_payment')} rules={[{ required: true, message: t('create_order_required') }]}>
                    <Input type={"number"} placeholder={t('create_order_required')} />
                </Form.Item>
                <Form.Item
                    name='orderInfo.contractDate'
                    label={t('create_order_contract_date')}
                    trigger='onConfirm'
                    onClick={(e, datePickerRef) => {
                        datePickerRef.current?.open();
                    }}
                    rules={[{ required: true, message: t('create_order_required') }]}>
                    <DatePicker>
                        {value => value ? dayjs(value).format('YYYY-MM-DD') : t('create_order_select_date')}
                    </DatePicker>
                </Form.Item>
                <Form.Item
                    name='orderInfo.countryCode'
                    label={t('create_order_country')}
                    trigger='onConfirm'
                    onClick={(e, pickerRef) => {
                        pickerRef.current?.open();
                    }}
                    rules={[{ required: false, message: t('create_order_required') }]}>
                    <Picker columns={[countList]}>
                        {value => value ? _getcountryDesc(value, false, false) : t('create_order_country')}
                    </Picker>
                </Form.Item>
                <Form.Item
                    name='orderInfo.cityCode'
                    label={t('create_order_city')}
                    trigger='onConfirm'
                    onClick={(e, pickerRef) => {
                        pickerRef.current?.open();
                    }}
                    rules={[{ required: false, message: t('create_order_required') }]}>
                    <Picker columns={[cityList]}>
                        {value => value ? _getDistrictDesc(value) : t('create_order_city')}
                    </Picker>
                </Form.Item>
                <Form.Item
                    name='orderInfo.districtCode'
                    label={t('create_order_district')}
                    trigger='onConfirm'
                    onClick={(e, pickerRef) => {
                        pickerRef.current?.open();
                    }}
                    rules={[{ required: false, message: t('create_order_required') }]}>
                    <Picker columns={[districtList]}>
                        {value => value ? _getCommonDesc(value) : t('create_order_district')}
                    </Picker>
                </Form.Item>
                {/*<Form.Item*/}
                {/*    name='orderInfo.orderType'*/}
                {/*    label={t('create_order_order_type')}*/}
                {/*    rules={[{ required: true, message: t('create_order_select_order_type') }]}>*/}
                {/*    <Selector options={orderTypeList} />*/}
                {/*</Form.Item>*/}
                <Form.Item name='orderInfo.loanDaysType' label={t('create_order_loan_days')} rules={[{ required: true, message: t('create_order_select_loan_days') }]}>
                    <Selector options={loanDaysList} />
                </Form.Item>
                <Form.Header>{t('create_order_store_select_title')}</Form.Header>
                <Form.Item
                    name="store"
                    label="Please Select A Store"
                    rules={[{ required: true, message: 'Please Select A Store' }]}
                    onClick={() => setStoreSelectorVisible(true)}>
                    <div className="store-selector-trigger">
                        {selectedStore ? (
                            <div className="selected-store-preview">
                                <div className="store-name">{selectedStore.storeName}</div>
                                <div className="store-address">{selectedStore.storeAddress}</div>
                            </div>
                        ) : (
                            <div className="placeholder">Click To Select A Store ({Object.values(filteredGroupedStores).reduce((acc, cur) => acc + cur.length, 0)} Options)</div>
                        )}
                    </div>
                </Form.Item>
            </Form>
            <Modal
                visible={storeSelectorVisible}
                title={t('store_select_title')}
                content={
                    <div className="store-selector-modal">
                        {/* 搜索栏 */}
                        <div className="search-section">
                            <SearchBar
                                placeholder="Search For Store Name"
                                value={searchValue}
                                onChange={setSearchValue}
                                onClear={() => setSearchValue('')}
                            />
                            <div className="search-tips">
                                Total {Object.values(filteredGroupedStores).reduce((acc, stores) => acc + stores.length, 0)} Stores
                                {searchValue && ` (Search: "${searchValue}")`}
                            </div>
                        </div>

                        {/* 店铺列表 */}
                        <div className="store-list-section">
                            {Object.keys(filteredGroupedStores).length > 0 ? (
                                <IndexBar>
                                    {Object.keys(filteredGroupedStores).map(groupKey => (
                                        <IndexBar.Panel
                                            key={groupKey}
                                            index={groupKey}
                                            title={`${groupKey} (${filteredGroupedStores[groupKey].length})`}>
                                            <div className="store-group">
                                                {filteredGroupedStores[groupKey].map(store => (
                                                    <div
                                                        key={store.id}
                                                        className={`store-item ${selectedStore?.id === store.id ? 'selected' : ''}`}
                                                        onClick={() => handleStoreSelect(store)}>
                                                        <div className="store-item-content">
                                                            <div className="store-name">{store.storeName}</div>
                                                            <div className="store-address">{store.storeAddress}</div>
                                                        </div>
                                                        {selectedStore?.id === store.id && (
                                                            <div className="selected-indicator">✓</div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </IndexBar.Panel>
                                    ))}
                                </IndexBar>
                            ) : (
                                <div className="empty-state">
                                    {searchValue ? 'No Matching Store Found' : 'No Data Available'}
                                </div>
                            )}
                        </div>
                    </div>
                }
                closeOnAction
                onClose={() => {
                    setStoreSelectorVisible(false);
                    setSearchValue('');
                }}
                actions={[
                    {
                        key: 'cancel',
                        text: 'Cancel',
                    }
                ]}
            />
        </div>
    </div>
}
export default CreateOrder;
